Vue.component('showMedal', {
  template: templates.showMedal,
  data() {
    return {
      model: {
        medals: [],
        medal: null,
        show: false,
        audio: null
      }
    }
  },
  mounted() {
    const c = this;
    
    c.model.audio = new Audio('../audio/award-01.mp3');
    c.getMedals();
  },
  methods: {
    getMedals() {
      const c = this;

      medalService.queue()
        .then(function (response) {
          c.model.medals = response.data;
          c.showMedals();
        })
        .catch(function (error) {
          setTimeout(function() {
            c.getMedals();
          }, 5000);
        });
    },
    showMedals() {
      const c = this;

      if (c.model.medals.length) {
        c.showMedal(c.model.medals[0]);
      } else {
        c.getMedals();
      }
    },
    showMedal(medal) {
      const c = this;

      twitchAPI.getUsersById([{twitchId: medal.twitchId}], function(userData) {

        for (let d of userData) {

          c.model.medal = medal;

          c.model.medal.twitchDisplayName = d.display_name;
          c.model.medal.twitchProfileImage = d.profile_image_url
          c.model.medal.src = `https://sgtwoofy.com/videos/medals/${medal.medalId}.webm`;

          c.saveMedal(medal);

          setTimeout(function() {
            c.model.show = true;
            c.model.audio.play();
          }, 300);

          setTimeout(function() {
            c.model.show = false;
            setTimeout(function() {
              c.model.medals.shift();
              c.showMedals();
            }, 1000);
          }, 10000);
          
        }

      });

    },
    saveMedal(medal) {
      const c = this;
      medalService.saveMedal({id: medal.id});
    }
  }
});